<template>
  <div class="noticias" style="height: calc(100% - 40px)">
      <h4 class="mx-2 text-secondary">Procedimientos</h4>
      <div class="cartelera procedimiento" v-if="noticias">
        <router-link :to="'/noticias/mostrar/'+noticia.uuid" v-for="noticia,i in procedimientos" :key="i+noticia.titulo" :class="'w-100 card card-'+noticia.tipo">
          <h4 class="card-title">{{noticia.titulo}}</h4>
          <p>Presione para ver la noticia</p>
        </router-link>
      </div>
  </div>
  
  </template>
  <script>
import { NoticiasServices } from '../../noticias/services/NoticiasServices'
  export default {
    name: 'ProcedimientosView',
    data(){
        return {
            noticias: null
        }
    },
    created(){
        NoticiasServices.api.getCartelera()
        .then((response) => {
        this.noticias = response
        })
    },
    computed: {
      procedimientos: function(){
        if(this.noticias === null) return []
        else{
            const procedimientos = []
            for(const diaria of this.noticias.diarias){
              if(diaria.tipo === 'procedimiento'){
                procedimientos.push(diaria)
              }
            }
            for(const ultima of this.noticias.ultimas){
              if(ultima.tipo === 'procedimiento'){
                procedimientos.push(ultima)
              }
            }
            if(this.noticias.procedimiento){
              procedimientos.push(...this.noticias.procedimiento)
            }
            return procedimientos
        }
      }
    }
  }
  </script>
  <style scoped>
  .noticias .cartelera.procedimiento{
    display: block;
  }
  .noticias .cartelera.procedimiento > .card{
    display: block;
  }
  </style>